var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatusCanceled = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 4.5C16.1421 4.5 19.5 7.85786 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5ZM15.7881 8.21191C15.4953 7.91927 15.0204 7.91938 14.7275 8.21191L12 10.9395L9.27393 8.21191C8.98103 7.91902 8.50481 7.91902 8.21191 8.21191C7.91936 8.50462 7.91966 8.97957 8.21191 9.27246L10.9395 12L8.21191 14.7275C7.91966 15.0204 7.91936 15.4954 8.21191 15.7881C8.50481 16.081 8.98103 16.081 9.27393 15.7881L12 13.0605L14.7275 15.7881C15.0204 16.0806 15.4953 16.0807 15.7881 15.7881C16.0809 15.4953 16.0807 15.0205 15.7881 14.7275L13.0605 12L15.7881 9.27246C16.0807 8.97954 16.0809 8.5047 15.7881 8.21191Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatusCanceled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/status-canceled.21e44ec316cb1cf52ee0074c68b8ba97.svg";